export default __webpack_public_path__ + "static/media/clinical-symptoms-graph.04b08cbc.png";